import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clock',
  templateUrl: './clock.component.html',
  styleUrls: ['./clock.component.css']
})
export class ClockComponent implements OnInit {
  time = new Date();
  private timer;

  constructor() { }

  ngOnInit() {
    //   setInterval(() => {
    //     this.time = new Date();
    // }, 1000);

    this.timer = setInterval(() => {
      this.time = new Date();
    }, 1000);
  }

  routerOnDeactivate() {
    clearInterval(this.timer);
  }
}
